import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import {
  IClinicOverrides,
  ISaveClinicOverridesPayload,
} from '@dataTypes/clinic-overrides.type'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchClinicOverridesApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ clinic_overrides: IClinicOverrides }>> => {
  const response = await axios.get<
    ApiEnvelope<{ clinic_overrides: IClinicOverrides }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/overrides`, {
    params: { clinic_id: clinicId },
  })
  return response.data
}

export const saveClinicOverridesApi = async (
  clinicId: string,
  payload: ISaveClinicOverridesPayload,
): Promise<ApiEnvelope<{ clinic_overrides: IClinicOverrides }>> => {
  const response = await axios.put<
    ApiEnvelope<{ clinic_overrides: IClinicOverrides }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/overrides/${clinicId}`, payload)
  return response.data
}
